import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AuthorizeUserTree from './authorizeUserTree.component';
import { shortTypes as assignmentTypes } from './assignmentTypes';
import permissionTypes from './permissionTypes';
import { MenuLink } from '../../menu/menuLink.component';

class AuthorizedLink extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    withPermissions: PropTypes.arrayOf(PropTypes.shape({
      permissionType: PropTypes.oneOf(Object.values(permissionTypes)).isRequired,
      permissionPath: PropTypes.string.isRequired,
    })).isRequired,
    withAssignments: PropTypes.arrayOf(PropTypes.shape({
      assignmentType: PropTypes.oneOf(Object.values(assignmentTypes)).isRequired,
      requiredPermission: PropTypes.string.isRequired,
    })),
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    listElementClassName: PropTypes.string,
    otherwise: PropTypes.node,
    disabled: PropTypes.bool,
    disabledReason: PropTypes.string,
  };

  static defaultProps = {
    withPermissions: [],
    withAssignments: [],
  };

  render() {
    const {
      withPermissions,
      withAssignments,
      to,
      children,
      className,
      listElementClassName,
      otherwise,
      disabled,
      disabledReason,
    } = this.props;

    return (
      <AuthorizeUserTree
        withPermissions={withPermissions}
        withAssignments={withAssignments}
        className={className}
        listElementClassName={listElementClassName}
        otherwise={otherwise}
      >
        <MenuLink to={to} disabled={disabled} disabledReason={disabledReason}>
          {children}
        </MenuLink>
      </AuthorizeUserTree>
    );
  }
}

export default AuthorizedLink;
